import React, { MouseEvent } from 'react';
import { CardHeader, Typography } from '@mui/material';
import { IconButton } from '@components/iconButton';
import { ellipsis } from '@theme/styles';
import { Times } from '@assets/svgs';
import { icon, FallbackIcon } from './NotificationCard.icon';
import { IconName } from '@lio/rule-engine';

export type INotificationCardHeader = {
  iconName: IconName | null;
  heading: string | undefined;
  createdAt: string | undefined;
  onDismiss: () => void;
};

export const NotificationCardHeader = (props: INotificationCardHeader) => {
  const { iconName, heading, createdAt, onDismiss } = props;

  if (!heading || !createdAt) return null;

  const handleNotificationDismiss = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    onDismiss();
  };

  return (
    <CardHeader
      sx={{
        color: ({ palette }) => `${palette.text.main}90`,
      }}
      disableTypography
      title={
        <>
          {iconName ? icon[iconName] : FallbackIcon}
          <Typography
            variant='tableHeader'
            sx={{
              color: 'gray4',
              marginLeft: 1,
              maxWidth: '250px',
              ...ellipsis,
              fontWeight: 'bold',
            }}
          >
            {heading}
          </Typography>
        </>
      }
      action={
        <>
          <Typography
            variant='caption'
            sx={{
              color: 'white100',
            }}
          >
            {createdAt}
          </Typography>
          <IconButton variant='circularDark' size='small' onClick={handleNotificationDismiss}>
            <Times id='timesIcon' />
          </IconButton>
        </>
      }
    />
  );
};
